import { z } from 'zod';

// Story 12.11 — relatórios financeiros (série temporal MRR/ARR + churn + LTV).

export const mrrSeriesPointSchema = z.object({
  date: z.string(), // 'YYYY-MM-DD' (fuso BR)
  mrrTotal: z.number(),
  arrTotal: z.number(),
  arpu: z.number().nullable(),
  activeClientsCount: z.number().int(),
  churnRate: z.number().min(0).nullable(),
  ltvEstimate: z.number().nullable(),
});

export const mrrSeriesResponseSchema = z.object({
  data: z.object({
    series: z.array(mrrSeriesPointSchema),
    _meta: z.object({
      churnNote: z.string(),
      ltvNote: z.string(),
      // FR-59.7 stretch — cohort/retenção não disponível sem refactor (AC8).
      cohortAnalysis: z.literal('not_available'),
    }),
  }),
});

export const mrrByProductResponseSchema = z.object({
  data: z.object({
    date: z.string().nullable(),
    byProduct: z.array(
      z.object({
        productName: z.string(),
        mrrTotal: z.number(),
        clientCount: z.number().int(),
      }),
    ),
  }),
});

export type MrrSeriesPoint = z.output<typeof mrrSeriesPointSchema>;
export type MrrSeriesResponse = z.output<typeof mrrSeriesResponseSchema>;
export type MrrByProductResponse = z.output<typeof mrrByProductResponseSchema>;
